import axios from 'axios';
import { MetaUlHistoryEntry, MetaUlResponse } from './types';

export async function fetchMetasUl(year: string): Promise<MetaUlResponse> {
  try {
    const { data } = await axios.get<MetaUlResponse>('/datatransfer/metas-unilever', {
      params: { year },
    });
    return data;
  } catch (error: any) {
    return error?.response?.data || {
      success: false,
      error: 'N\u00e3o foi poss\u00edvel carregar as Metas UL',
    };
  }
}

export async function saveMetasUl(year: string, rows: string[][]): Promise<MetaUlResponse> {
  try {
    const { data } = await axios.put<MetaUlResponse>('/datatransfer/metas-unilever', {
      year,
      rows,
    });
    return data;
  } catch (error: any) {
    return error?.response?.data || {
      success: false,
      error: 'N\u00e3o foi poss\u00edvel salvar as Metas UL',
    };
  }
}

export async function fetchMetasUlHistory(): Promise<MetaUlHistoryEntry[]> {
  const { data } = await axios.get<{ success: boolean; data: MetaUlHistoryEntry[] }>(
    '/datatransfer/metas-unilever/history'
  );
  return data?.data || [];
}
